export default __webpack_public_path__ + "static/launch-partner_meebits_logo@2x-f39fb97009d00c761c3c947897dc42f2.png";